// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"30ffe06c","143":"cbe1948d","381":"1d9f811b","494":"626250a4","533":"02065213","682":"3077580c","852":"928e4d59","858":"32b6f91a","940":"b93e0e6e"}[chunkId] + ".chunk.js";
};